import * as React from 'react';

import Typography from 'antd/lib/typography';
const { Text } = Typography;
import {
    Value,
    Values,
} from 'one-ui-values';

import {
    PendingBillsModel,
} from './model';


import {
    buildGearActionsMenu,
} from 'one-ui-gear/src/actions';

import {
    PendingBillsCardProps,
} from './props';

import {
    CardLight,
} from 'one-ui-card/src/card-light';

import Skeleton from 'antd/lib/skeleton';
import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';
import {
    CardNoData
} from 'one-ui-card';
import { useCtx } from "one-ui-provider";
/**
 * This function returns the pending bills
 * @param props has all thee input parameters to load the card
 * @returns JSX code Pending Bills Card
 */

export const PendingBillsCard = <M extends PendingBillsModel>(
    props: PendingBillsCardProps<M>
) => {
    const {
        model,
        title,
        gearActions = [],
        skeleton,
    } = props;

    let {
        totalpendingbills,
        totalbalance,
        insurancebalance,
        servicearea
    } = model || {};

    const {
        pendingBills_skeleton,
    } = skeleton;
    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;
    //Initial
    let result = (
        <div>
            <div className="line-description">
                <div className="line-description__item">
                    <div className="line-description__item-title">Bills</div>
                    <div className="line-description__item-note">{totalpendingbills}</div>
                </div>
                <div className="line-description__item">
                    <div className="line-description__item-title">Patient</div>
                    <div className="line-description__item-note">
                        <Text type="danger">${totalbalance}<i></i></Text>
                    </div>
                </div>
                <div className="line-description__item">
                    <div className="line-description__item-title">Insurance</div>
                    <div className="line-description__item-note">
                        ${insurancebalance}<i></i>
                    </div>
                </div>
            </div>
            <div className="description-info">
                <div className="description-info__item" style={{ marginTop: "10px" }}>
                    <Values>
                        <Value label="Service Area" value={servicearea} />
                    </Values>
                </div>
            </div>
        </div>
    );


    // If pending bills skeleton is true
    if (pendingBills_skeleton) {
        result = (<Skeleton active paragraph={{ rows: 1 }} />);
    }

    if((totalpendingbills === null ||
        totalpendingbills === undefined) && !pendingBills_skeleton){
        result = 
        <>
            <CardNoData/>
        </>
    }

    else if(checkCardHasError('Billing') && servicearea === undefined){
        result = 
        <>
            <CardErrorMsg />
        </>
    }

    // Based on billingInformation flag If billingInformation flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.billingInformation){
        result = 
        <>
            <CardLockIcon />
        </>
        return (
            <CardLight
                title={title}
                body={
                    result
                }
            />
        );
    }
    else {
        return (
            <CardLight
                title={title}
                gearActions={
                    buildGearActionsMenu(
                        gearActions,
                    )
                }
                body={
                    result
                }
            />
        );
    }
};
